export default "__VITE_ASSET__De8mpP9D__"